
    import {useStore} from "@/store";
    import checkTitle from './checkTitle.vue';
    import checkDescrip from './checkDescrip.vue';
    import checkPosition from './checkPosition.vue';
    import checkContent from './checkContent.vue';
    import {defineComponent, ComputedRef, computed, reactive, watch} from 'vue';

    interface State {
        showDescrip: boolean;
        tocOnlyShowFlaw: boolean;
    }
    export default defineComponent({
        name: 'checkItem',
        props: {
            renderData: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            dataIndex: {
                type: Object,
                default: -1
            }
        },
        setup() {
            let state: State = reactive({
                showDescrip: false,
                tocOnlyShowFlaw: false,
            }); 
            let store = useStore();
            let tocOnlyShowFlawS: ComputedRef<{}> = computed<{}>(() => store.state.tocOnlyShowFlaw)
            watch(tocOnlyShowFlawS, (data: any) => {
                state.tocOnlyShowFlaw = data;
            }, {immediate: true})
            return {
                state
            }
        },
        components: {
            checkTitle,
            checkDescrip,
            // checkPosition,
            checkContent,
        }
    })
